// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import Vuelidate from '@vuelidate/core';
import { createGettext } from 'vue3-gettext';

const translations = require('./i18n/output/' + (process.env.VUE_APP_SITE || 'rr') + '/translations.json');
const app = createApp(App);

// Vuelidate
app.use(Vuelidate);

// vue3-gettext
app.use(
  createGettext({
    availableLanguages: {
      'en-GB': 'English UK',
      'de-DE': 'German Germany',
      'fr-CA': 'French Canada',
    },
    defaultLanguage: 'en-GB',
    translations: translations || {},
    silent: true,
  }),
);

// Router
app.use(router);

// Sentry integration (Raven is deprecated, use @sentry/vue for Vue 3)
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';
// Sentry.init({
//   app,
//   dsn: 'https://6f34bcc0a77d4d9e8152ab6f7a5a3e41@sentry2.tuimedia.com/77',
//   integrations: [new BrowserTracing({ routingInstrumentation: Sentry.vueRouterInstrumentation(router) })],
//   tracesSampleRate: 1.0,
// });

app.mount('#app');
